import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4fdeea4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "planEdit" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "修改回访计划", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { updateVisit } from "../../config/interface";
import { ElMessage } from "element-plus";
import type { ElForm } from "element-plus";
type FormInstance = InstanceType<typeof ElForm>;


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const formRef = ref<FormInstance>();
const router = useRouter();
const route = useRoute();
let back = "<";
// 临时存放计划信息
const planInfo = ref<any>({
	visitDay: ""
});
// 点击提交按钮，请求接口
const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      console.log("submit!", planInfo.value);
			let params = {
				id: planInfo.value.id,
				visitDay: planInfo.value.visitDay
			}
			updateVisit(params).then((res)=>{
				if(res.data.data && res.data.success) {
					ElMessage.success(res.data.msg)
					router.back();
				} else {
					ElMessage.error(res.data.msg)
				}
			})
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
const handleBack = () => {
  router.back();
};
onMounted(() => {
	if (route.params) {
    let temp = JSON.parse(route.params.info as string);
    planInfo.value = temp;
		console.log(planInfo.value);
		
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "back",
        onClick: handleBack
      }, _toDisplayString(_unref(back)) + " 返回", 1)
    ]),
    _hoisted_3,
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: planInfo.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "回访时间",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: planInfo.value.visitDay,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((planInfo.value.visitDay) = $event)),
              type: "date",
              format: "YYYY/MM/DD",
              "value-format": "YYYY-MM-DD",
              placeholder: "请选择回访时间"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { prop: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (submitForm(formRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})